<div class="monitoring maximized-component">
    <div class="grids-container">
        <div id="left-grids-section">
            <div id="realm-nodes-grid-section" [ngStyle]="{'height' : showAEComponentsandStorageGrids ? '33%' : 'calc(100% - 30px)'}">
                <res-generic-grid #realmNodesGrid [gridName]="realmNodesGridName" [automationId]="realmNodegridAutoID"
                    [headerTemplate]="realmNodesHeaderTemplate" [(isBusy)]="isrealmNodesGridBusy" [(isBusyMessage)]="realmNodesGridBusyMessage"
                    [columnDefs]="realmNodesColDefs" [requestInfo]="realmNodesGridRequestInfo" [gridContext]="realmNodesGridContext"
                    [responseArrayCallback]="realmNodesResponseArrayCallback" [rowSelection]="realmNodesGridRowSelection"
                    [pagerVisible]="false" [onRowClickedCallback]="onRealmNodesGridRowClickedCallback" [showHeaderContextMenu]="false">
                </res-generic-grid>
                <ng-template #realmNodesHeaderTemplate>
                    <div class='parent-header'>
                        <span class="header-title">Realm Nodes</span>
                        <span class="right-side-text">
                            <div class="buttons-section">
                                <button type="button" class="secondary-button" [attr.data-automation-id]="connectorsGridAutoID + '-update-button'" (click)="updateGrids()">
                                    <i class="fa fa-refresh"></i> Update All
                                </button>
                                <button type="button" class="help-button" [attr.data-automation-id]="connectorsGridAutoID + '-help-button'" (click)="openHelp()">
                                    <i class="fa fa-question"></i>
                                </button>
                            </div>
                        </span>
                    </div>
                </ng-template>
            </div>
            <div class="bottom-panel-info" [hidden]="showAEComponentsandStorageGrids">Select a Realm Node to see its AE Components and Storage</div>
            <res-resizer anchor="up" ellipsisExpander="true" resizingElementId="realm-nodes-grid-section" secondElementId="ae-components-grid-section"
            [collapsible]="false" [minSize]="30" [maxSize]="33" [usePercentages]="true" [hidden]="!showAEComponentsandStorageGrids"></res-resizer>
            <div id="ae-components-grid-section" [hidden]="!showAEComponentsandStorageGrids">
                <res-generic-grid #aeComponentsGrid [gridName]="asComponentsGridName" [automationId]="aeComponentsGridAutoID"
                    [headerTemplate]="aeComponentsGridHeaderTemplate" [(isBusy)]="isaeComponentsGridBusy" [showHeaderContextMenu]="false" [(isBusyMessage)]="aeComponentsGridBusyMessage"
                    [columnDefs]="aeComponentGridColDef"
                    [pagerVisible]="false">
                </res-generic-grid>
                <ng-template #aeComponentsGridHeaderTemplate>
                    <div class='parent-header'>
                        <span class="header-title">AE Components - {{ selectedRealmNodeName }}</span>
                    </div>
                </ng-template>
            </div>
            <res-resizer anchor="up" ellipsisExpander="true" resizingElementId="ae-components-grid-section" secondElementId="storage-grid-section"
            [collapsible]="false" [minSize]="30" [maxSize]="33" [initSize]="33" [usePercentages]="true" [hidden]="!showAEComponentsandStorageGrids"></res-resizer>
            <div id="storage-grid-section" [hidden]="!showAEComponentsandStorageGrids">
                <res-generic-grid #storageGrid [gridName]="storageGridName" [automationId]="storageGridAutoID"
                    [headerTemplate]="storageGridHeaderTemplate" [(isBusy)]="isStorageGridBusy" [(isBusyMessage)]="storageGridBusyMessage"
                    [columnDefs]="storageGridColDef" [gridContext]="storageGridContext" [showHeaderContextMenu]="false"
                    [pagerVisible]="false">
                </res-generic-grid>
                <ng-template #storageGridHeaderTemplate>
                    <div class='parent-header'>
                        <span class="header-title">Storage - {{ selectedRealmNodeName }}</span>
                    </div>
                </ng-template>
            </div>
        </div>
        <res-resizer [attr.data-automation-id]="'monitoring-resizer'" anchor="left"
            resizingElementId="left-grids-section" secondElementId="connectors-grid-section" [usePercentages]="true"
            [initSize]="50" [minSize]="30" [ellipsisExpander]="true"></res-resizer>
        <div id="connectors-grid-section">
            <div class="right-content">
                <div id="connectorsgridSection" [hidden]="!showAEComponentsandStorageGrids" [ngStyle]="{'height' : connectorsGridSelectedRow ? '50%' : 'calc(100% - 30px)'}">
                <res-generic-grid #connectorsGrid [gridName]="connectorsGridName" [automationId]="connectorsGridAutoID"
                    [headerTemplate]="connectorsGridHeaderTemplate" [(isBusy)]="isConnectorsGridBusy" [(isBusyMessage)]="connectorsGridBusyMessage"
                    [onRowClickedCallback]="onConnectorsGridRowClickedCallback" [columnDefs]="connectorsGridColDef" [pagerVisible]="false" 
                    [showHeaderContextMenu]="false" [gridContext]="connectorGridContext" [rowSelection]="connectorsGridRowSelection">
                </res-generic-grid>
                <ng-template #connectorsGridHeaderTemplate>
                    <div class='parent-header'>
                        <span class="header-title">Connectors - {{ selectedRealmNodeName }}</span>
                    </div>
                </ng-template>
                </div>

                <res-resizer anchor="up" [hidden]="!connectorsGridSelectedRow" ellipsisExpander="true" resizingElementId="connectorsgridSection" secondElementId="dataAreasGridSection"
                    [collapsible]="false" [minSize]="30" [maxSize]="50" [usePercentages]="true"></res-resizer>

                <div id="dataAreasGridSection" [hidden]="!connectorsGridSelectedRow">
                    <res-generic-grid #dataAreasGrid [hidden]="!connectorsGridSelectedRow" [showHeaderContextMenu]="false" [headerTemplate]="dataAreasGridHeaderTemplate" 
                    [gridName]="dataAreaGridName" [automationId]="dataAreasGridAutoId" [(isBusy)]="isDataAreasGridBusy" [(isBusyMessage)]="isDataAreasGridBusyMessage" 
                    [columnDefs]="dataAreasColDef" [pagerVisible]="false" [gridContext]="dataAreasGridContext">
                </res-generic-grid>
                <ng-template #dataAreasGridHeaderTemplate>
                    <div class='parent-header'>
                        <span class="header-title">Data Areas - {{ selectedConnectorGridName }}</span>
                    </div>
                </ng-template>
                </div>
            </div>
            <div class="bottom-panel-info" [hidden]="showAEComponentsandStorageGrids && connectorsGridSelectedRow">{{rightBottomPanelText}}</div>
        </div>
    </div>
</div>